module.exports = __webpack_public_path__ + "img/EAI06_L.70f9cfbd.png";